import React, {useEffect, useState} from 'react';
import {useRecoilValue} from 'recoil';
import {userState} from '../../../../recoil/user/userAtom';
import {
  Collapse,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from '@mui/material';
import {
  ContactSupportOutlined,
  ExitToApp,
  ExpandLess,
  ExpandMore,
  FeedbackOutlined,
} from '@mui/icons-material';
import {useListStyles} from './MenuStyles';
import LoginDialog from '../../components/LoginDialog';
import {NavigationPath} from '../SelectedIndexUtil';
import Anchor from '../../../../common/Anchor';

interface IProps {
  width: number;
  isLoggedIn: boolean;
  selectedIndex: NavigationPath;
  handleListItemClick: (navigationPath: NavigationPath) => void;
  handleLogoutClick: () => void;
}

export const ItemsCommon: React.FC<IProps> = (props) => {
  const classes = useListStyles(props.width)();
  const user = useRecoilValue(userState);
  const [bidmiiProInfoOpen, setBidmiiProInfoOpen] = useState(false);
  const [howItWorksOpen, setHowItWorksOpen] = useState(false);
  const [aboutUsOpen, setAboutUsOpen] = useState(false);
  // const [legalOpen, setLegalOpen] = useState(false);
  const [contactOpen, setContactOpen] = useState(false);
  const {selectedIndex, handleListItemClick} = props;
  const isMobileLayout = props.width < 601;

  useEffect(() => {
    [NavigationPath.BIDMII_PRO, NavigationPath.SUBSCRIPTIONS].includes(
      selectedIndex,
    ) && setBidmiiProInfoOpen(true);
    [
      NavigationPath.HOW_IT_WORKS,
      NavigationPath.FAQ,
      NavigationPath.HELP_ARTICLES,
    ].includes(selectedIndex) && setHowItWorksOpen(true);

    [NavigationPath.ABOUT, NavigationPath.BLOG].includes(selectedIndex) &&
      setAboutUsOpen(true);

    // [NavigationPath.TERMS, NavigationPath.PRIVACY].includes(selectedIndex) &&
    //   setLegalOpen(true);

    [NavigationPath.CONTACT].includes(selectedIndex) && setContactOpen(true);
  }, [selectedIndex]);

  return (
    <>
      <ListItem
        button
        disableGutters
        key="bidmiiProOpen"
        onClick={() => setBidmiiProInfoOpen(!bidmiiProInfoOpen)}
        classes={{
          root: classes.drawerItemHeading,
          selected: classes.drawerItemSelected,
        }}>
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="BIDMII PRO"
        />
        {bidmiiProInfoOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={bidmiiProInfoOpen} timeout="auto" unmountOnExit>
        <Anchor href={NavigationPath.BIDMII_PRO}>
          <ListItem
            button
            key="bidmiipro"
            selected={selectedIndex === NavigationPath.BIDMII_PRO}
            onClick={() => handleListItemClick(NavigationPath.BIDMII_PRO)}
            classes={{
              root: classes.drawerItemRoot,
              selected: classes.drawerItemSelected,
            }}>
            <ListItemText
              primaryTypographyProps={{variant: 'subtitle2'}}
              primary="OVERVIEW"
            />
          </ListItem>
        </Anchor>
        <Anchor href={NavigationPath.SUBSCRIPTIONS}>
          <ListItem
            button
            key={NavigationPath.SUBSCRIPTIONS}
            selected={selectedIndex === NavigationPath.SUBSCRIPTIONS}
            onClick={() => handleListItemClick(NavigationPath.SUBSCRIPTIONS)}
            classes={{
              root: classes.drawerItemRoot,
              selected: classes.drawerItemSelected,
            }}>
            <ListItemText
              primaryTypographyProps={{variant: 'subtitle2'}}
              primary="SUBSCRIPTION PLANS"
            />
          </ListItem>
        </Anchor>
        {/* <Anchor href={NavigationPath.CDAP}>
          <ListItem
            button
            key="cdap-grant"
            selected={selectedIndex === NavigationPath.CDAP}
            onClick={() => handleListItemClick(NavigationPath.CDAP)}
            classes={{
              root: classes.drawerItemRoot,
              selected: classes.drawerItemSelected,
            }}>
            <ListItemText
              primaryTypographyProps={{variant: 'subtitle2'}}
              primary="CONTRACTOR GRANT"
            />
          </ListItem>
        </Anchor> */}
      </Collapse>
      <Divider style={{margin: '4px 0'}} />
      <ListItem
        button
        disableGutters
        key="howItWorks"
        onClick={() => setHowItWorksOpen(!howItWorksOpen)}
        classes={{
          root: classes.drawerItemHeading,
          selected: classes.drawerItemSelected,
        }}>
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="HOW IT WORKS"
        />
        {howItWorksOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={howItWorksOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Anchor href={NavigationPath.HOW_IT_WORKS}>
            <ListItem
              button
              key="overview"
              selected={selectedIndex === NavigationPath.HOW_IT_WORKS}
              onClick={() => handleListItemClick(NavigationPath.HOW_IT_WORKS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="OVERVIEW"
              />
            </ListItem>
          </Anchor>
          {/* <Anchor href={NavigationPath.PRICING}>
            <ListItem
              button
              key={NavigationPath.PRICING}
              selected={selectedIndex === NavigationPath.PRICING}
              onClick={() => handleListItemClick(NavigationPath.PRICING)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="PRICING"
              />
            </ListItem>
          </Anchor> */}
          <Anchor href="https://finance.bidmii.com/">
            <ListItem
              button
              key="bidmii-finance"
              onClick={() =>
                window.open(
                  'https://finance.bidmii.com/',
                  '_blank',
                  'noopener,noreferrer',
                )
              }
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="BIDMII FINANCE"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.FAQ}>
            <ListItem
              button
              key={NavigationPath.FAQ}
              selected={selectedIndex === NavigationPath.FAQ}
              onClick={() => handleListItemClick(NavigationPath.FAQ)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="F.A.Q."
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.HELP_ARTICLES}>
            <ListItem
              button
              key={NavigationPath.HELP_ARTICLES}
              selected={selectedIndex === NavigationPath.HELP_ARTICLES}
              onClick={() => handleListItemClick(NavigationPath.HELP_ARTICLES)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="HELP ARTICLES"
              />
            </ListItem>
          </Anchor>
        </List>
      </Collapse>
      <Divider style={{margin: '4px 0'}} />
      <ListItem
        button
        disableGutters
        key="aboutUs"
        onClick={() => setAboutUsOpen(!aboutUsOpen)}
        classes={{
          root: classes.drawerItemHeading,
          selected: classes.drawerItemSelected,
        }}>
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="ABOUT US"
        />
        {aboutUsOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={aboutUsOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Anchor href={NavigationPath.ABOUT}>
            <ListItem
              button
              key={NavigationPath.ABOUT}
              selected={selectedIndex === NavigationPath.ABOUT}
              onClick={() => handleListItemClick(NavigationPath.ABOUT)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="OUR COMPANY"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.BLOG}>
            <ListItem
              button
              key={NavigationPath.BLOG}
              selected={selectedIndex === NavigationPath.BLOG}
              onClick={() => handleListItemClick(NavigationPath.BLOG)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="BLOG"
              />
            </ListItem>
          </Anchor>
          {/* <Anchor href={NavigationPath.CAREERS}>
            <ListItem
              button
              key={NavigationPath.CAREERS}
              selected={selectedIndex === NavigationPath.CAREERS}
              onClick={() => handleListItemClick(NavigationPath.CAREERS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="CAREERS"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.SAFETY}>
            <ListItem
              button
              key={NavigationPath.SAFETY}
              selected={selectedIndex === NavigationPath.SAFETY}
              onClick={() => handleListItemClick(NavigationPath.SAFETY)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="SAFETY"
              />
            </ListItem>
          </Anchor> */}
        </List>
      </Collapse>
      {/* <Divider style={{margin: '4px 0'}} />
      <ListItem
        button
        disableGutters
        key="legal"
        onClick={() => setLegalOpen(!legalOpen)}
        classes={{
          root: classes.drawerItemHeading,
          selected: classes.drawerItemSelected,
        }}>
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="LEGAL"
        />
        {legalOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={legalOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Anchor href={NavigationPath.TERMS}>
            <ListItem
              button
              key={NavigationPath.TERMS}
              selected={selectedIndex === NavigationPath.TERMS}
              onClick={() => handleListItemClick(NavigationPath.TERMS)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="TERMS & CONDITIONS"
              />
            </ListItem>
          </Anchor>
          <Anchor href={NavigationPath.PRIVACY}>
            <ListItem
              button
              key={NavigationPath.PRIVACY}
              selected={selectedIndex === NavigationPath.PRIVACY}
              onClick={() => handleListItemClick(NavigationPath.PRIVACY)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="PRIVACY POLICY"
              />
            </ListItem>
          </Anchor>
        </List>
      </Collapse> */}
      <Divider style={{margin: '4px 0'}} />
      <ListItem
        button
        disableGutters
        key="contact"
        onClick={() => setContactOpen(!contactOpen)}
        classes={{
          root: classes.drawerItemHeading,
          selected: classes.drawerItemSelected,
        }}>
        <ListItemText
          primaryTypographyProps={{variant: 'subtitle2'}}
          primary="CONTACT"
        />
        {contactOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={contactOpen} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {user && (
            <ListItem
              button
              key={NavigationPath.FEEDBACK}
              selected={selectedIndex === NavigationPath.FEEDBACK}
              onClick={() => handleListItemClick(NavigationPath.FEEDBACK)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              {isMobileLayout && (
                <ListItemIcon>
                  <FeedbackOutlined />
                </ListItemIcon>
              )}
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="FEEDBACK"
              />
            </ListItem>
          )}
          <Anchor href={NavigationPath.CONTACT}>
            <ListItem
              button
              key={NavigationPath.CONTACT}
              selected={selectedIndex === NavigationPath.CONTACT}
              onClick={() => handleListItemClick(NavigationPath.CONTACT)}
              classes={{
                root: classes.drawerItemRoot,
                selected: classes.drawerItemSelected,
              }}>
              {isMobileLayout && (
                <ListItemIcon>
                  <ContactSupportOutlined />
                </ListItemIcon>
              )}
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="GET SUPPORT"
              />
            </ListItem>
          </Anchor>
        </List>
      </Collapse>
      <div style={{marginBottom: 'auto'}}>
        <Divider style={{margin: '4px 0'}} />
        {props.width < 601 && props.isLoggedIn && (
          <Grid item style={{marginTop: 8, marginBottom: 32}}>
            <ListItem
              button
              key="logout"
              classes={{root: classes.drawerItemRoot}}
              onClick={props.handleLogoutClick}>
              <ListItemIcon>
                <ExitToApp />
              </ListItemIcon>
              <ListItemText
                primaryTypographyProps={{variant: 'subtitle2'}}
                primary="SIGN OUT"
              />
            </ListItem>
          </Grid>
        )}
        {props.width < 601 && !props.isLoggedIn && (
          <Grid item style={{marginTop: 16, marginBottom: 32}}>
            <LoginDialog isMobile={true} />
          </Grid>
        )}
      </div>
    </>
  );
};
